export var BLANK_ANNOTATIONS_XFDF = '<xfdf><annots/></xfdf>';
export function getAnnotationIdsFromXfdf(xfdfString) {
  var result = [];
  var xmlDoc = new DOMParser().parseFromString(xfdfString, 'text/xml');
  var queryResult = xmlDoc.evaluate("//*[name()='xfdf']/*[name()='annots']/*/@name", xmlDoc, null, XPathResult.ANY_TYPE);
  var node;
  while (node = queryResult.iterateNext()) {
    var _node;
    if ((_node = node) !== null && _node !== void 0 && _node.textContent) {
      result.push(node.textContent);
    }
  }
  return result;
}
